import React from 'react';
export function SolutionSection() {
  return <section className="bg-bg py-16 px-5 text-center" data-id="element-122">
      <div className="container-custom" data-id="element-123">
        <div className="max-w-[640px] mx-auto" data-id="element-124">
          <span className="section-tag mx-auto" data-id="element-125">La solución definitiva</span>
          <p className="text-lg text-muted leading-[1.7] mb-6" data-id="element-126">
            Si querés crear postres artísticos que se venden solos y generar
            ingresos reales desde casa —{' '}
            <strong className="text-text font-bold" data-id="element-127">
              sin cursos eternos, sin inversión enorme, sin adivinar pasos
            </strong>{' '}
            — encontraste exactamente lo que necesitabas.
          </p>

          <div className="inline-block font-serif text-[clamp(28px,4vw,44px)] text-white border-2 border-pink rounded-lg py-3.5 px-9 my-3" data-id="element-128">
            Gelatinas de <em className="text-pink italic" data-id="element-129">Lujo</em>
          </div>

          <p className="text-[15px] text-muted mt-2.5" data-id="element-130">
            El Método Más Completo para Crear Gelatinas Artísticas y Venderlas
            Desde Casa
          </p>
        </div>
      </div>
    </section>;
}